/**
 * The veil and the card in front of the bench.
 *
 * It was written by hand three times inside `screens/receiving/receiving.tsx`
 * — the delivery notes, the article search, the cancel-arrival dialog — and the
 * camera would have been the fourth. The fourth is the one that made the
 * duplication expensive: it holds a `MediaStream`, and a copy written by hand
 * puts the cleanup somewhere nobody looks for it.
 *
 * The component owns exactly two decisions and nothing else.
 *
 * **It closes on `mousedown`, and only when the veil itself is the target.**
 * A `click` on the overlay would also fire for a drag that starts inside the
 * card and ends outside it: selecting text in the article search would close
 * the panel it was selecting from.
 *
 * **It does not listen for Escape**, deliberately. The station keeps a single
 * global key handler (`receiving.tsx`), because two listeners on the same key
 * argue with each other: Escape has to close *whatever is in front*, and that
 * is a question one place can answer and two cannot agree on. Bringing Escape
 * in here would resurrect exactly the conflict that comment describes.
 */

import type { ReactNode } from 'react';

export interface PropsModale {
  /** Come si chiama il dialogo per chi non lo vede. */
  readonly etichetta: string;
  /**
   * `alertdialog` per i gesti distruttivi, che pretendono una risposta prima
   * di lasciar fare altro; `dialog` per i pannelli, che sono una strada in più.
   */
  readonly ruolo?: 'dialog' | 'alertdialog';
  /** I pannelli larghi (bolle, ricerca articolo); i dialoghi no. */
  readonly larga?: boolean;
  readonly onChiudi: () => void;
  readonly children: ReactNode;
}

export function Modale({ etichetta, ruolo = 'dialog', larga, onChiudi, children }: PropsModale) {
  return (
    <div className="velo" onMouseDown={(e) => e.target === e.currentTarget && onChiudi()}>
      <div
        className={larga ? 'scheda scheda--larga' : 'scheda'}
        role={ruolo}
        aria-label={etichetta}
      >
        {children}
      </div>
    </div>
  );
}
